import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http, formatApiErrorDetail } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = logged out
  const [error, setError] = useState(null);

  const bootstrap = useCallback(async () => {
    try {
      const { data } = await http.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(false);
    }
  }, []);

  useEffect(() => { bootstrap(); }, [bootstrap]);

  const login = async (email, password) => {
    setError(null);
    try {
      const { data } = await http.post("/auth/login", { email, password });
      if (data.access_token) localStorage.setItem("shopmerse_token", data.access_token);
      setUser(data);
      return true;
    } catch (e) {
      setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
      return false;
    }
  };

  const logout = async () => {
    try { await http.post("/auth/logout"); } catch {}
    localStorage.removeItem("shopmerse_token");
    setUser(false);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, error, setError, bootstrap }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
